export enum DocumentTypeEnum {
  OfflinePracticeFormInstance = 1,
  OfflinePractitionerFormInstance = 2,
  SurveyPack = 3,
  Guidelines = 4,
  Report = 5,
}
